export default "__VITE_ASSET__bf7b3aa6__"